<script setup>
import {Link}  from '@inertiajs/vue3';

import {ref, onMounted, onUnmounted} from 'vue';

const showDropdown = ref(false);

import { contact_information } from "~app_root/public/tv/app.config";

</script>

<template>

	<div>

		<div class="dropdown-menu-wrapper" id="contact-menu-wrapper">

			<div class="p-1 lnr" @click="showDropdown = !showDropdown">
				<i class="lnr icon-telephone"></i>
				<span class="d-none d-xl-inline">{{
						__('contact')
					}}</span>
			</div>

			<transition name="fade-y">

				<ul class="dropdown-menu-content" v-if="showDropdown">

					<li class="dropdown-title">
						<span class="font-semibold text-black text-nowrap">{{__('contact_information')}}</span>
					</li>

					<li v-for="(phone, pKey) in contact_information.phones">
						<a :href="'tel:' + phone.value">
							<i class="lnr icon-telephone"></i>
							<span>{{ phone.label }}</span>
						</a>
					</li>

					<li class="border-top-1">
						<a :href="'mailto:' + contact_information.email">
							<i class="lnr icon-at-sign"></i>
							<span>{{ contact_information.email }}</span>
						</a>
					</li>

				</ul>

			</transition>

		</div>

		<div class="dropdown-menu-background" v-if="showDropdown" @click="showDropdown = false"></div>

	</div>

</template>

<script>
export default {
	name: "ContactInfoMenuItem"
}
</script>

<style scoped>

</style>